import React, {useState, useRef, useEffect, InputHTMLAttributes} from 'react';
import {formatDate} from '../../../../../utils/date';
import InputGradient from '../input-gradient/input-gradient';

interface DateInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
    id?: string;
    label?: string;
    error?: string;
    classNameLabel?: string;
    type?: string;
    className?: string;
    placeHolder?: string;
    value?: string;
    isLoading?: boolean;
    onValueChange?: (value: string) => void;
}

const DateInputGradient: React.FC<DateInputProps> = ({
    label,
    error,
    classNameLabel,
    className,
    value = '',
    disabled,
    placeHolder,
    onValueChange,
    ...rest
}) => {
    const [inputValue, setInputValue] = useState(value);
    const prevValue = useRef(value);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const current = e.target.value;
        const isDeleting = current.length < prevValue.current.length;
        let nextValue = current;

        if (!isDeleting) {
            nextValue = formatDate(current);
        }

        setInputValue(nextValue);
        prevValue.current = nextValue;
        onValueChange?.(nextValue);
    };

    useEffect(() => {
        setInputValue(value);
        prevValue.current = value;
    }, [value]);

    return (
        <InputGradient
            {...rest}
            type="text"
            label={label}
            error={error}
            classNameLabel={classNameLabel}
            className={className}
            value={inputValue}
            disabled={disabled}
            placeholder={placeHolder}
            maxLength={10}
            onChange={handleChange}
            aria-label="Nhập ngày"
        />
    );
};

export default DateInputGradient;
